import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import YumChallengeTitle from './YumChallengeTitle'
import { getUserGoal } from '../../views/Activity/store/ActivitySelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any) => ({
  goal: getUserGoal(state, ownProps.goalId),
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(YumChallengeTitle)
